import CardContainer from "@/common/cards/CardContainer";
import ListView from "@/common/custom-lists/ListView";
import TableViewList from "@/common/custom-selectors/TableViewList";
import { orderBy } from "lodash";
import { useMemo, useState } from "react";
import { connect } from "react-redux";
import ClientRow from "./CompanyRow";

const viewOptions = ["Normal", "Card"].map((value) => ({ label: value, value }));

const SelectACompany = ({ organisations }) => {
	const storedView = localStorage.getItem("advisor-client-view");
	const [view, setView] = useState(viewOptions.find(({ value }) => value == storedView) || viewOptions[0]);

	const columns = useMemo(() => {
		const columns = [];

		switch (view?.value) {
			case "Card":
				columns.push(...["Clients"]);
				break;
			case "Normal":
				columns.push(...[{ hidden: true }, "Company", "Status", { hidden: true }]);
				break;
		}
		return columns;
	}, [view?.value]);

	const filteredClients = useMemo(() => {
		return organisations;
	}, [organisations]);

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Select A Company</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="clearfix" />
			<div className="content bg-white">
				<ListView
					{...{
						title: "Client",
						items:
							view?.value !== "Card"
								? filteredClients?.map((client) => (
										<ClientRow
											key={client.id}
											client={client}
											view={view?.value}
										/>
								  ))
								: null,
						columns,
						viewList: (
							<div className="pull-right">
								<TableViewList
									options={viewOptions}
									value={view}
									onChange={(option) => {
										setView(option);
										localStorage.setItem("advisor-client-view", option.value);
									}}
								/>
							</div>
						),
					}}
				/>
				{view?.value === "Card" ? (
					<CardContainer>
						{filteredClients?.map((client) => (
							<ClientRow
								key={client.id}
								client={client}
								view={view?.value}
							/>
						))}
					</CardContainer>
				) : null}
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		organisations: orderBy(state?.organisations, (o) => o?.name?.toLowerCase()) || [],
		isAdmin: state.my.profile.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SelectACompany);
